export default __webpack_public_path__ + "static/media/board.7afe3a54.png";